import { z } from 'zod';
import { endpoint } from './endpoint.js';
import { MediaUnitFiltersSchema } from '../schemas/media-units.js';
import { CampaignFilterPresetSchema } from '../schemas/campaign-filter-preset.js';

const idParamsSchema = z.object({ id: z.coerce.number() });

export const campaignFilterPresets = {
  get: endpoint('GET', '/campaigns/:id/filter-preset', idParamsSchema, CampaignFilterPresetSchema),
  upsert: endpoint(
    'PUT',
    '/campaigns/:id/filter-preset',
    z.object({ id: z.coerce.number(), filters: MediaUnitFiltersSchema }),
    CampaignFilterPresetSchema,
  ),
};
